<template>
    <div class="certificate-page">
        <div v-for="it in list" :key="it.title">
            <div class="shopping-title">
                <h1>{{ it.title }}</h1>
                <i></i>
            </div>
            <img :src="it.url" :alt="it.title">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                { title: '营业执照', url: 'http://www.360pyyy.com/images/yyzz.jpg' },
                { title: '药品经营许可证', url: 'http://www.360pyyy.com/images/ypjyxkz.png' },
                { title: '第二类医疗器械经营备案凭证', url: 'http://www.360pyyy.com/images/delylqxjybapz.jpg' },
                { title: '医疗器械经营许可证', url: 'http://www.360pyyy.com/images/ylqxjyxkz.png' },
                { title: '互联网药品信息服务资格证书', url: 'http://www.360pyyy.com/images/hlwypxxfwzgzs.png' },
            ]
        }
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.certificate-page {
    width: 1200px;
    margin: 0 auto;

    h1 {
        margin: 24px 0;
    }

    img {
        width: 1200px;
    }
}

.shopping-title {
    @include flex-d-c;
    align-items: center;
    margin: 40px 0 34px 0;

    h1 {
        font-size: 28px;
        color: #333333;
        font-weight: 400;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        span {
            font-weight: bold;
        }

        &::before {
            content: "";
            display: inline-block;
            width: 18px;
            height: 1px;
            background-color: #e2e2e2;
            line-height: 40px;
            margin-right: 36px;
        }

        &::after {
            content: "";
            display: inline-block;
            width: 18px;
            height: 1px;
            background-color: #e2e2e2;
            line-height: 40px;
            margin-left: 36px;
        }
    }

    i {
        display: block;
        width: 30px;
        height: 4px;
        background-color: #fa4b4b;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/certificate/index.vue